import { ApiClient } from '@/lib/apiClient'
import type { CreateLocation, Location } from '@/types/location'

export default class LocationService extends ApiClient<Location, CreateLocation> {
  constructor() {
    super('/v1/site', 'number');
  }
}
